import React from 'react';
import {Field, FieldProps} from 'formik';

interface ElogTextareaProps {
    label: string;
    name: string;
    mandatory?: boolean;
}

const ElogTextarea: React.FC<ElogTextareaProps> = ({label, name, mandatory = false}) => {
    return (
        <tr>
            <th>
                {mandatory && <span>*</span>}
                {label}:
            </th>
            <td>
                <Field name={name}>
                    {({field}: FieldProps) => (
                        <textarea
                            id={name}
                            cols={40}
                            rows={3}
                            className="small"
                            {...field}
                        />
                    )}
                </Field>
            </td>
        </tr>
    );
};

export default ElogTextarea;